import axios from "axios";

const baseApiUrl = process.env.REACT_APP_API_URL;
const apiKey = process.env.REACT_APP_API_KEY;

const instance = axios.create({
  baseURL: `${baseApiUrl}/bowlingcenters`,
});

const fetchBC = () => {
  return instance
    .get(`/`, {
      headers: { apiKey: apiKey, "Content-Type": "application/json" },
    })
    .then(({ data }) => data);
  //.catch((e) => console.log(e.response.data.message));
};

const getCenterById = (centerId) => {
  return instance
    .get(`/${centerId}`, {
      headers: { apiKey: apiKey, "Content-Type": "application/json" },
    })
    .then(({ data }) => data);
  //.catch((e) => console.log(e.response.data.message));
};

const getPlayersByBC = (uuid) => {
  return instance
    .get(`/${uuid}/live`, {
      headers: { apiKey: apiKey, "Content-Type": "application/json" },
    })
    .then(({ data }) => data);
};

export { getCenterById, fetchBC, getPlayersByBC };
